import { defineStore, acceptHMRUpdate } from "pinia"
import type { Create, DepartmentsRecord, Update } from "@/pocketbase-types"
import { sortBy } from "@/utils"

export const useDepartmentStore = defineStore("department", {
  state: () => ({
    departments: [] as DepartmentsRecord[]
  }),
  getters: {},
  actions: {
    async refresh() {
      this.departments = await this.pb.collection("departments").getFullList({ sort: "+name" })
    },
    async create(props: Omit<Create<"departments">, "household">) {
      const dept = await this.pb
        .collection("departments")
        .create({ ...props, household: this.pb.authStore.record?.household })
      this.departments.push(dept)
      this.departments.sort(sortBy(d => d.name))
    },
    async update(dept: DepartmentsRecord, props: Update<"departments">) {
      const updated = await this.pb.collection("departments").update(dept.id, props)
      const idx = this.departments.findIndex(d => d.id == dept.id)

      if (idx > -1) {
        this.departments.splice(idx, 1, updated)
        this.departments.sort(sortBy(d => d.name))
      } else {
        await this.refresh()
      }
    },
    async delete(dept: DepartmentsRecord) {
      await this.pb.collection("departments").delete(dept.id)
      const idx = this.departments.findIndex(d => d.id == dept.id)
      if (idx > -1) {
        this.departments.splice(idx, 1)
      }
    }
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useDepartmentStore, import.meta.hot))
}
